export class MediaUploadDefaultError extends Error {
  constructor() {
    super()
    this.message = 'mediaUpload.error.default'
  }
}
